import { useEffect } from 'react';

/**
 * Un message qui survit a un changement d'ecran.
 *
 * Le signalement se fait maintenant sur son propre ecran : quand il
 * aboutit, on revient d'ou l'on vient, et c'est la-bas que « Merci, on
 * regarde ca » doit s'afficher. L'ecran d'arrivee etant demonte pendant
 * qu'on remplit le formulaire, il ne peut pas garder ce message pour
 * lui : on le depose ici, il le ramasse en se remontant.
 *
 * `navigate(-1)` ne transporte pas d'etat — il rejoue une entree
 * d'historique deja ecrite — d'ou ce relais plutot qu'un `state` de
 * navigation.
 */
let pending: string | null = null;

/** Depose le message avant de quitter l'ecran. */
export function leaveFlash(message: string): void {
  pending = message;
}

/** Le ramasse, une seule fois. */
export function takeFlash(): string | null {
  const message = pending;
  pending = null;
  return message;
}

/**
 * A afficher a l'arrivee, s'il y a quelque chose.
 *
 * Au montage seulement : c'est exactement le moment ou l'on revient sur
 * ses pas, et le meme montage relit les donnees — le post qu'on vient de
 * signaler a donc deja disparu quand le message s'affiche.
 */
export function useFlashOnArrival(show: (message: string) => void): void {
  useEffect(() => {
    const message = takeFlash();
    if (message) show(message);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
